module.exports = __webpack_public_path__ + "img/olt_8kl.7b362daf.jpg";